'use client'

import { createClientComponentClient } from '@gyym/auth-helpers'
import { GyymProvider } from '@gyym/sdk-react'
import {
  Config as GyymUiConfig,
  defaultTheme,
  DialogProvider,
  GyymUiProvider,
  ModalProvider,
  SnackbarProvider,
} from '@gyym/ui'
import type { SWRConfiguration } from 'swr'

import StyledComponentsRegistry from '@/lib/registry/styled-components'
import { PasskeyPromotionWatcher } from '@/modules/Passkey'
import { isPagesRouterPath } from '@/utils/isPagesRouterPath'

const client = createClientComponentClient()

const gyymUiConfig: GyymUiConfig = {
  imageHost: process.env.NEXT_PUBLIC_IMAGE_HOST,
  nextjs: {
    disableNextLink: false,
    disableNextImage: false,
    disableImageOptimization: false,
    // Pages Router 行きリンクの prefetch は「破棄される HTML のために
    // getServerSideProps をフル実行させる」だけの無駄なので無効化する
    // (App ⇄ Pages 間の遷移は必ずハードナビゲーションになる)
    disableLinkPrefetch: isPagesRouterPath,
  },
}

export default function Providers({
  children,
  swr,
}: {
  children: React.ReactNode
  swr?: SWRConfiguration
}) {
  return (
    <GyymProvider
      client={client}
      swr={{
        ...swr,
        fallback: {
          ...swr?.fallback,
        },
      }}
    >
      <StyledComponentsRegistry>
        <GyymUiProvider theme={defaultTheme} config={gyymUiConfig}>
          <SnackbarProvider>
            <ModalProvider>
              <DialogProvider>
                {children}
                <PasskeyPromotionWatcher />
              </DialogProvider>
            </ModalProvider>
          </SnackbarProvider>
        </GyymUiProvider>
      </StyledComponentsRegistry>
    </GyymProvider>
  )
}
